<div class="form-bx mb-4" fxLayout="row wrap" class="mtb-2">
    <div fxFlex="100%" class="pb-2" fxLayoutAlign="center">
        {{msg}}
    </div>
    <div fxFlex="100%" fxLayoutAlign="center">
        <button fxFlex="100px" fxFlex.xs="100%" mat-button class="btn-primary warning-btn" (click)="back()">Ok</button>
    </div>
    <div fxFlex="100%" fxLayoutAlign="center" *ngIf="data['cancelButton']">
        <button fxFlex="100px" fxFlex.xs="100%" mat-button class="btn-secondary" (click)="back()">Cancel</button>
    </div>
</div>